import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-notes',
  templateUrl: './add-notes.component.html',
  styleUrls: ['./add-notes.component.scss']
})
export class AddNotesComponent implements OnInit {

  submitted:boolean = false;
  notes:string = '';
  constructor(
    public dialogRef: MatDialogRef<AddNotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if(this.data.notes){
      this.notes = this.data.notes
    }
  }

  add(){
    this.submitted = true;
    if(this.notes !== ''){
      this.dialogRef.close({notes:this.notes});
    }
  }
}
